import React, { useEffect, useState } from 'react';
import Login from '@components/Login';
import { configureAmplify, exporter, shouldSkipUILogin } from '@utils/auth.utils';
import { AuthStorageKeys } from '@utils/localStorageAuthUtils.utils';
import { AuthConfiguration, AuthConfigurationV2 } from '../auth/auth.types';
import { getAuthProviderByType } from '../auth/authenticationProviderFactory';
import { ProvideAuth } from './amplifyProvider';

export default function AuthProvider({ children }: React.PropsWithChildren = {}) {
  const [authConfig, setAuthConfig] = useState<AuthConfigurationV2 | AuthConfiguration | null>(
    JSON.parse(localStorage.getItem(AuthStorageKeys.authConfig) || 'null')
  );
  const [isCurrentlyLoggingIn, setIsCurrentlyLoggingIn] = useState<boolean>(false);
  const authPlatform = authConfig && 'provider' in authConfig ? getAuthProviderByType(authConfig?.provider) : undefined;
  useEffect(() => {
    const checkTokenInLocalStorage = event => {
      if (
        (event.key === AuthStorageKeys.accessTokenByAccountId && event.oldValue === null) || // login
        (event.key === AuthStorageKeys.authConfig && event.newValue === null) // logout
      ) {
        window.location.reload();
      }
    };
    window.addEventListener('storage', checkTokenInLocalStorage);
    return () => window.removeEventListener('storage', checkTokenInLocalStorage);
  }, []);

  useEffect(() => {
    if (authConfig && 'connectionDetails' in authConfig) {
      authPlatform?.configureAuthProvider();
    } else if (authConfig) {
      configureAmplify(authConfig);
    }
  }, [authConfig]);

  if (exporter() && shouldSkipUILogin()) {
    return <ProvideAuth isCurrentlyLoggingIn={isCurrentlyLoggingIn}>{children}</ProvideAuth>;
  }
  if (!authConfig) {
    return <Login setAuthConfig={setAuthConfig} setIsCurrentlyLoggingIn={setIsCurrentlyLoggingIn} />;
  }

  return <ProvideAuth isCurrentlyLoggingIn={isCurrentlyLoggingIn}>{children}</ProvideAuth>;
}
